export default "__VITE_ASSET__0ae56641__"